// @ts-nocheck
import { HISTORY_ERROR, HISTORY_LOADING, HISTORY_SUCCESS} from "../Type";
import * as Authservices from '../../Services/services';

export const history = (data) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch({
                type: HISTORY_LOADING,
                data: true
            })
            Authservices.history(data).then((response) => {
                if (response?.status === 200) {
                    dispatch({
                        type: HISTORY_SUCCESS,
                        data: response?.data
                    })
                    return resolve(response?.data);
                }
            }).catch((error) => {
                if (error) {
                    dispatch({
                        type: HISTORY_ERROR,
                        data: {message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'}
                    })
                }
                return reject({message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'})
            })
        })
    }
}